module.exports = require('../en.json')